export default __webpack_public_path__ + "static/media/s-2.71ab563a.jpg";